/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'activity-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 945.23a39.385 39.385 0 0039.385 39.385H945.23a39.385 39.385 0 0039.384-39.384V428.268H0v516.963zM945.23 88.616H738.463V9.846A9.846 9.846 0 00728.615 0h-68.923a9.846 9.846 0 00-9.846 9.846v78.77H334.77V9.845A9.846 9.846 0 00324.923 0H256a9.846 9.846 0 00-9.846 9.846v78.77H39.384A39.385 39.385 0 000 128v216.615h984.615V128a39.385 39.385 0 00-39.384-39.385z"/>'
  }
})
